import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import withRouter from '../../services/util/withRouter';
import { path } from 'd3';

const mapStateToProps = state => ({
	user: state.user
});

const SafePrivateRoute = (props) => {	
	const { user, location, children } = props;
	let hasAccess = user !== null;

	if (hasAccess) {
		let pathname = location.pathname;
		if (pathname.startsWith("/vms/")) {
			//If the path is under /vms/, we need to check only for /vms permission
			pathname = "/vms";
		}
		//Convert to string
		const permission = JSON.stringify(user.permission);

		//Check if the path is included in permissions
		if (!permission.includes(pathname)) {
			//If not, set access to false which will redirect to login
			hasAccess = false;
		}
	}

	// Handle case where children might be wrapped in an object
	const childrenToRender = children?.children || children;

	return hasAccess ? (
		childrenToRender
	) : (
		<Navigate to="/login" replace />
	);
};

export default connect(mapStateToProps)(withRouter(SafePrivateRoute));
